const Logo = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { height: "h-8", maxWidth: "max-w-[140px]" },
    default: { height: "h-10", maxWidth: "max-w-[180px]" },
    large: { height: "h-14", maxWidth: "max-w-[240px]" }
  };
  const s = sizes[size] || sizes.default;
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo-c2.png" 
        alt="C2 Assurances" 
        className={`${s.height} ${s.maxWidth} w-auto object-contain`}
        style={{ filter: 'brightness(0) invert(1)' }}
      />
    </div>
  );
};

export const LogoBlue = ({ className = "", size = "default" }) => {
  const sizes = {
    small: { height: "h-8", maxWidth: "max-w-[140px]" },
    default: { height: "h-10", maxWidth: "max-w-[180px]" },
    large: { height: "h-14", maxWidth: "max-w-[240px]" }
  };
  const s = sizes[size] || sizes.default;
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo-c2.png" 
        alt="C2 Assurances" 
        className={`${s.height} ${s.maxWidth} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
